export default __webpack_public_path__ + "static/my_car-f12343e3afa3bfc4fa2399366cb66e48.jpg";